var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEndpointMainnetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.99985C4.88308 8.99985 4.76819 8.9724 4.66667 8.9202L2.33333 7.71783C2.127 7.61163 2 7.41544 2 7.20275V4.7974C2 4.58501 2.127 4.38851 2.33333 4.28202L4.66667 3.07965C4.76819 3.02745 4.88308 3 5 3C5.11692 3 5.23181 3.02745 5.33333 3.07965L7.66667 4.28202C7.76773 4.33383 7.85179 4.40875 7.91032 4.49921C7.96886 4.58966 7.9998 4.69243 8 4.7971V7.20244C8 7.41484 7.873 7.61133 7.66667 7.71783L5.33333 8.9202C5.23181 8.9724 5.11692 8.99985 5 8.99985ZM5 8.99985V6.00007M5 6.00007L7.91 4.48811M5 6.00007L2.09 4.48811",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 1.25,
    r: 0.75,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.75,
    cy: 8.75,
    r: 0.75,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 8.75,
    r: 0.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndpointMainnetWhite);
export default __webpack_public_path__ + "static/media/icon-endpoint-mainnet-white.4968bc3afb1d812f029a4987518ecdd6.svg";
export { ForwardRef as ReactComponent };